import React, { useState } from "react";
import { Link } from "react-router-dom";

const WelcomeBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "70px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#f3e1b2",
        padding: "15px 20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 100,
        width: "90%",
        maxWidth: "600px",
        textAlign: "center",
        animation: "fadeIn 0.5s ease-out",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "5px",
          right: "10px",
          background: "none",
          border: "none",
          fontSize: "18px",
          cursor: "pointer",
        }}
      >
        ✕
      </button>
      <h3
        style={{
          margin: "0 0 10px 0",
          color: "#333",
          fontSize: "24px",
          fontWeight: "700",
        }}
      >
        Welcome to Links!
      </h3>
      <p
        style={{
          margin: "0 0 15px 0",
          color: "#444",
          fontSize: "16px",
          lineHeight: "1.5",
        }}
      >
        Try our math learning platform with 5 free practice problems. Create an
        account to save your progress!
      </p>
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <Link
          to="/register"
          style={{
            padding: "8px 16px",
            backgroundColor: "#9CDAED",
            color: "#000",
            textDecoration: "none",
            borderRadius: "8px",
            fontWeight: "600",
            fontSize: "16px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          Sign Up
        </Link>
        <Link
          to="/login"
          style={{
            padding: "8px 16px",
            backgroundColor: "#ffffff",
            color: "#333",
            textDecoration: "none",
            borderRadius: "8px",
            fontWeight: "600",
            fontSize: "16px",
            border: "1px solid #ddd",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          Login
        </Link>
      </div>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translate(-50%, -20px); }
            to { opacity: 1; transform: translate(-50%, 0); }
          }
        `}
      </style>
    </div>
  );
};

export default WelcomeBanner;
